module.exports = __webpack_public_path__ + "static/media/room3blue.3190f591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/room3blue.png
// module id = 358
// module chunks = 0